import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { useLang, t } from '../../context/LanguageContext';
import T from '../../translations/index';

const ContactModal = ({ open, onClose }) => {
  const { lang } = useLang();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('/send_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString(),
      });

      const result = await response.json();
      
      if (response.ok) {
        setSuccess(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        alert(result.success || 'Message sent successfully!');
        setTimeout(() => {
          onClose();
          setSuccess(false);
        }, 1000);
      } else {
        alert(result.error || 'Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          boxShadow: '0 24px 80px rgba(23, 60, 170, 0.22), 0 4px 16px rgba(0,0,0,0.12)',
          overflow: 'hidden',
        }
      }}
    >
      <DialogTitle className="modal-header">
        <div className="modal-title-wrapper">
          <Typography variant="h6" className="modal-title">
            {t(T.modalTitle, lang)}
          </Typography>
          <IconButton
            onClick={onClose}
            className="modal-close-btn"
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </div>
        <Typography variant="body2" className="modal-subtitle">
          {t(T.modalSubtitle, lang)}
        </Typography>
      </DialogTitle>

      <DialogContent className="modal-content">
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label={t(T.fullNameField, lang)}
            name="name"
            value={formData.name}
            onChange={handleChange}
            margin="normal"
            required
            variant="outlined"
            placeholder={t(T.fullNamePlaceholder, lang)}
            className="form-field"
          />
          <TextField
            fullWidth
            label={t(T.emailField, lang)}
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            required
            variant="outlined"
            placeholder={t(T.emailPlaceholder, lang)}
            className="form-field"
          />
          <TextField
            fullWidth
            label={t(T.subjectField, lang)}
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            margin="normal"
            required
            variant="outlined"
            placeholder={t(T.subjectPlaceholder, lang)}
            className="form-field"
          />
          <TextField
            fullWidth
            label={t(T.messageField, lang)}
            name="message"
            value={formData.message}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={5}
            required
            variant="outlined"
            placeholder={t(T.messagePlaceholder, lang)}
            className="form-field"
          />
        </form>
      </DialogContent>

      <DialogActions className="modal-actions">
        <Button 
          onClick={onClose}
          variant="outlined"
          className="modal-cancel-btn"
        >
          {t(T.cancelBtn, lang)}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
          endIcon={<SendIcon />}
          className="modal-submit-btn"
        >
          {loading ? t(T.sendingMsgBtn, lang) : t(T.sendMessageBtn, lang)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactModal;
